<template>
  <footer class="footer" ref="footerH" :class="{'footerBgr' : stickyBetslip, navigationDisabledDueBetPlacement: isNavigationDisabledDueBetPlacement}">
    <!-- RW -->
    <template v-if="brandKey === 'rw'">
      <div class="footer_logo">
        <img :src="mediaServer('/static/brand-img/rw/logo-circle.svg')" alt="" loading="lazy" />
      </div>
      <div class="igt_footer_nav">
        <site-navigation :navigation-section="'FOOTER_ABOUT'"></site-navigation>
      </div>
      <section class="bottom-info">
          <p>{{ $t('Footer.info.companyName', { currentYear: currentYear }) }}</p>
          <p>{{ $t('Footer.info.gamblingProblem') }}</p>
          <a class="rg" :href="$t('RGLink.' + state)">
            <img class="rg-logo" :src="mediaServer('/static/brand-img/' + brandKey + '/rg-logo.svg')" alt="" loading="lazy" />
            <span class="header-txt">{{ $t('Header.InfoMessageTwo') }}</span>
          </a>
          <p class="build_version_text" v-if="buildVersion">{{ buildVersion }}</p>
      </section>
      <section class="footer-bottom">
        <section class="back-to-top" @click="goBack()"><v-icon>expand_less</v-icon></section>
      </section>
    </template>
    <!-- SUPERBOOK & MAVERICK -->
    <template v-if="brandKey === 'sb' || brandKey === 'mav'">
      <div class="footer_logo">
        <img v-if="brandKey === 'sb'" :src="mediaServer('/static/brand-img/sb/logo-footer.png')" alt="" loading="lazy" />
        <img v-if="brandKey === 'mav'" :src="mediaServer('/static/brand-img/' + brandKey +'/footer-logo.png')" alt="" loading="lazy" />
      </div>
      <div class="footer_social">
        <site-navigation :navigation-section="'FOOTER_SOCIAL_ICONS'"></site-navigation>
      </div>
      <div v-if="brandKey === 'sb' && state ==='NJ'" class="dge">
        <img :src="mediaServer('/static/brand-img/sb/SB_NJ_DGE.png')" alt="" loading="lazy" />
      </div>
      <div v-if="brandKey === 'mav' && !mobileBigAndBelow" class="rg-footer">
        <div class="footer_info" v-html="$t('Footer.info')"></div>
      </div>
      <div v-if="!mobileBigAndBelow && brandKey === 'sb'" class="footer_info" v-html="$t('Footer.info.' + state, {mediaRGImg: mediaServer('/static/brand-img/' + brandKey +'/rg-logo.svg')})"></div>
      <div v-if="mobileBigAndBelow" class="rg-footer">
        <template v-if="brandKey === 'sb' && state !== 'VA'">
          <span v-if="brandKey === 'sb'">{{ $t('Footer.InfoMessageOne') }}</span>
          <span v-if="brandKey === 'sb'">{{ $t('Footer.InfoMessageTwo.' + state) }}</span>
          <div v-if="brandKey === 'sb'" class="logo-holder">
            <img v-if="state==='NJ'" @click.stop="go2ResponsibleGaming" class="rg-logo nj" :src="mediaServer('/static/brand-img/' + brandKey +'/rg-logo-nj.svg')" alt="" loading="lazy" />
            <img v-else class="rg-logo" :src="mediaServer('/static/brand-img/' + brandKey +'/rg-logo.svg')" alt="" loading="lazy" />
            <span v-if="state==='NJ'" @click.stop="go2ResponsibleGaming">{{ $t('Footer.InfoMessageThree') }}</span>
            <span v-if="state!=='NJ'"><a :href="$t('RGLink.' + state)">{{ $t('Footer.InfoMessageThree') }}</a></span>
          </div>
        </template>
        <template v-if="brandKey === 'sb' && state === 'VA'">
          <span class="m-b-7">{{ $t('Footer.InfoMessages.Superbook.VA.One') }}</span>
          <span class="m-b-7">{{ $t('Footer.InfoMessages.Superbook.VA.Two') }}</span>
          <span class="m-b-7">{{ $t('Footer.InfoMessages.Superbook.VA.Three') }}</span>
          <span class="m-b-7">{{ $t('Footer.InfoMessages.Superbook.VA.Four') }}</span>
          <span class="m-b-7">{{ $t('Footer.InfoMessages.Superbook.VA.Five') }}<a :href="'tel:' + $t('Footer.InfoMessages.Superbook.VA.Five.Phone')">{{ $t('Footer.InfoMessages.Superbook.VA.Five.Phone') }}</a>{{ $t('Footer.InfoMessages.Superbook.VA.Five.End') }}<a href='https://vcpg.net'>{{ $t('Footer.InfoMessages.Superbook.VA.Link1') }}</a></span>
          <span class="m-b-7"><a href='https://www.valottery.com/playingmatters/voluntaryexclusionprogram'>{{ $t('Footer.InfoMessages.Superbook.VA.Link2') }}</a></span><br>
          <div class="logo-holder">
            <img class="rg-logo" :src="mediaServer('/static/brand-img/' + brandKey +'/rg-logo.svg')" alt="" loading="lazy" />
            <span><a :href="$t('RGLink.' + state)">{{ $t('Footer.InfoMessageThree') }}</a></span>
          </div>
        </template>
        <div v-if="brandKey === 'mav'" class="logo-holder">
          <span><a :href="$t('RGLink.' + state)">{{ $t('Footer.InfoMessageThree') }}</a></span>
          <img class="rg-logo" :src="mediaServer('/static/brand-img/' + brandKey +'/rg-logo-white.svg')" alt="" loading="lazy" />
          <span>{{ $t('Footer.InfoMessageOne') }}</span>
          <span>{{ $t('Footer.InfoMessageTwo.' + state) }}</span>
        </div>
      </div>
      <div class="igt_footer_nav">
        <site-navigation :navigation-section="'FOOTER_ABOUT'"></site-navigation>
      </div>
      <section class="footer-bottom">
        <div class="footer_copyright">
          <span v-if="brandKey === 'sb'" class="copy_text">{{ $t('Footer.copyright.' + state, { currentYear: currentYear }) }}</span>
          <span v-if="brandKey === 'mav'" class="copy_text">{{ $t('Footer.copyright', { currentYear: currentYear }) }}</span>
          <div v-if="state === 'NJ' && isLoggedIn" class="current-time">{{ $t('MyAccount.SessionTime.' + state) }} {{sessionTime}}</div>
          <div v-if="state === 'NJ'" class="current-time">{{currentTime}}</div>
          <div class="build_version_text" v-if="buildVersion">{{ buildVersion }}</div>

        </div>
        <div class="back-to-top" @click="goBack()"><v-icon>expand_less</v-icon></div>
      </section>
    </template>
    <!-- QCasino -->
    <template v-if="brandKey === 'qcasino'">
      <div class="footer_logo">
        <img :src="mediaServer('/static/brand-img/' + brandKey +'/footer-logo.png')" alt="" loading="lazy" />
      </div>
      <div class="footer_social">
        <site-navigation :navigation-section="'FOOTER_SOCIAL_ICONS'"></site-navigation>
      </div>
      <div v-if="mobileBigAndBelow" class="rg-footer">
        <span>{{ $t('Footer.InfoMessageOne') }}</span>
        <span>{{ $t('Footer.InfoMessageTwo.' + state) }}</span>
        <div v-if="brandKey === 'qcasino'" class="logo-holder">
          <a :href="$t('RGLink.' + state)"><img class="rg-logo" :src="mediaServer('/static/brand-img/' + brandKey +'/rg-logo.svg')" alt="" loading="lazy" /></a>
          <span><a :href="$t('RGLink.' + state)">{{ $t('Footer.InfoMessageThree') }}</a></span>
        </div>
      </div>
      <div class="igt_footer_nav">
        <site-navigation :navigation-section="'FOOTER_ABOUT'"></site-navigation>
      </div>
      <section class="footer-bottom">
        <div class="footer_copyright">
          <span class="copy_text">{{ $t('Footer.copyright', { currentYear: currentYear }) }}</span>
        </div>
        <div class="back-to-top" @click="goBack()"><v-icon>expand_less</v-icon></div>
      </section>
    </template>
    <!-- GENERIC template-->
    <template v-if="brandLayout === 'generic' && brandKey !== 'generic-rilot'">
      <div class="footer_social">
        <site-navigation :navigation-section="'FOOTER_SOCIAL_ICONS'"></site-navigation>
      </div>
      <div class="igt_footer_nav">
        <site-navigation :navigation-section="'FOOTER_ABOUT'"></site-navigation>
      </div>
      <section class="bottom-info">
          <p>{{ $t('Footer.info.companyName', { currentYear: currentYear }) }}</p>
          <p>{{ $t('Footer.info.gamblingProblem') }}</p>
          <a class="rg" :target="isMobileApp ? '_self':'_blank'" :href="$t('RGLink.' + state)"><!--Url depend on STATE-->
            <img class="rg-logo" :src="mediaServer('/static/brand-img/' + brandKey + '/rg-logo.svg')" alt="" loading="lazy" />
            <span class="header-txt">{{ $t('Header.InfoMessageTwo') }}</span>
          </a>
          <p class="build_version_text" v-if="buildVersion">{{ buildVersion }}</p>
      </section>
      <section class="footer-bottom">
        <section class="back-to-top" @click="goBack()"><v-icon>expand_less</v-icon></section>
      </section>
    </template>
    <!-- GENERIC template END-->

    <!-- RILOT-->
    <template v-if="brandKey === 'generic-rilot'">
      <div class="footer-top footercontent">
        <div class="footer-top-left">
          <section class="company-pr">
            <div class="title">{{ $t('Footer.playResponsiblyTitle') }}</div>
            <div class="desc" v-html="$t('Footer.playResponsiblyDesc')"></div>
            <div class="link">
              <img :src="mediaServer('/static/brand-img/generic-rilot/footer/gamble-banner.png')" alt="" loading="lazy" class="footer-gamble-banner" />
              <router-link v-if="!$te('Footer.FindOutMore.LinkInternal') && !$te('Footer.FindOutMore.LinkExternal')" :to="{ name: 'info', params: { infopagename : 'responsible-gaming' }}">{{ $t('Footer.FindOutMore') }}</router-link>
              <router-link v-else-if="$te('Footer.FindOutMore.LinkInternal')" :to="{ path: '/' + $i18n.locale + $t('Footer.FindOutMore.LinkInternal') }">{{ $t('Footer.FindOutMore') }}</router-link>
              <a v-else-if="$te('Footer.FindOutMore.LinkExternal')" :href="$t('Footer.FindOutMore.LinkExternal')">{{ $t('Footer.FindOutMore') }}</a>
            </div>
          </section>
        </div>
        <div class="footer-top-right">
          <section class="social_and_contact">
            <section class="contact_us">
              <router-link  v-if="!$te('Footer.ContactUs.LinkInternal') && !$te('Footer.ContactUs.LinkExternal')" :to="{ name: 'info', params: { infopagename : 'contact' }}">{{ $t('Footer.ContactUs') }}</router-link>
              <router-link v-else-if="$te('Footer.ContactUs.LinkInternal')" :to="{ path: '/' + $i18n.locale + $t('Footer.ContactUs.LinkInternal') }">{{ $t('Footer.ContactUs') }}</router-link>
              <a v-else-if="$te('Footer.ContactUs.LinkExternal')" :href="$t('Footer.ContactUs.LinkExternal')">{{ $t('Footer.ContactUs') }}</a>
            </section>
          </section>
          <section class="partners">
            <site-navigation :navigation-section="'PARTNERS'"></site-navigation>
          </section>
        </div>
      </div>
      <section class="ri-ocean-state">
        <section class="footercontent">
          <div class="col-left"><img :src="mediaServer('/static/brand-img/generic-rilot/footer/ri-badge.jpg')" alt="" loading="lazy" class="footercontent-badge" /></div>
          <div class="col-right">{{ $t('Footer.oceanState') }}</div>
        </section>
        <section class="footer-bottom">
          <div class="bottom-info">
            <div v-if="!isMobileApp" class="app-links">
              <site-navigation :navigation-section="'LINK_TO_APPS'"></site-navigation>
            </div>
          </div>
        </section>
      </section>
      <div class="igt_footer_nav">
        <site-navigation :navigation-section="'FOOTER_ABOUT'"></site-navigation>
      </div>
      <section class="footer-bottom">
        <div class="bottom-info">
          <p>{{ $t('Footer.info.companyName', { currentYear: currentYear }) }}</p>
          <p class="build_version_text" v-if="buildVersion">{{ buildVersion }}</p>
        </div>
        <section class="back-to-top" @click="goBack()"><v-icon>expand_less</v-icon></section>
      </section>
    </template>
  </footer>
</template>

<script>
  import config from '@/config'
  import SiteNavigation from '@/components/common/SiteNavigation'
  import Branding from '@/components/mixins/Branding'
  import Screen from '@/components/mixins/Screen'
  import Url from '@/components/mixins/Url'
  import router from '@/router'
  import store from '@/store'
  import scrollToTop from '@/library/scrollToTop.js'

  export default {
    name: 'FooterPart',

    mixins: [
      Branding,
      Url,
      Screen
    ],

    components: {
      SiteNavigation
    },

    data () {
      return {
        currentTime: null,
        sessionTime: 0
      }
    },

    computed: {
      config () {
        return config
      },
      state () {
        return config.app.autoconf.STATE
      },
      buildVersion () {
        return window.ctsautoconf && window.ctsautoconf.BUILD_VERSION && window.ctsautoconf.BUILD_VERSION !== 'BUILD_VERSION' ? window.ctsautoconf.BUILD_VERSION : undefined
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      currentYear () {
        let year = (new Date()).getFullYear()
        return year
      },
      isMobileApp () {
        return window.ctsautoconf.MOBILE_LS || false
      },
      stickyBetslip () {
        return window.ctsautoconf.STICKY_BETSLIP || false
      },
      dateFormats () {
        return config.app.dateFormats
      },
      isNavigationDisabledDueBetPlacement () {
        return store.getters['sbBetslipState/isNavigationDisabledDueBetPlacement']
      }
    },

    methods: {
      updateCurrentTime () {
        this.currentTime = (new Date()).toLocaleString(this.dateFormats.locale, {timeZone: config.app.timeZone})
      },
      footerHeight () {
        if (this.$refs.footerH) {
          store.commit('screenState/setFooterHeight', this.$refs.footerH.clientHeight)
        }
      },
      goBack () {
        setTimeout(() => {
          scrollToTop('smooth')
        }, 200)
      },
      go2ResponsibleGaming () {
        if (router.currentRoute.path !== '/info/responsible-gaming') {
          router.push({ path: '/info/responsible-gaming' })
        } else return false
      }
    },
    created () {
      this.currentTime = (new Date()).toLocaleString(this.dateFormats.locale, {timeZone: config.app.timeZone})
      setInterval(() => this.updateCurrentTime(), 1 * 1000)
      setInterval(() => {
        let value = Math.round(Math.abs(localStorage.loginTime - Date.now()) / 1000)
        if (value >= 0) {
          let minutes = Math.floor(value / 60)
          let seconds = value - minutes * 60
          seconds = (seconds < 10 ? ('0' + seconds) : seconds)
          minutes = (minutes < 10 ? ('0' + minutes) : minutes)
          this.sessionTime = `${minutes}:${seconds}`
        }
      }, 1000)
      /* window.addEventListener('load', () => {
        this.footerHeight()
      }) */
    },
    mounted () {
      setTimeout(() => {
        this.footerHeight()
      }, 1000)
    },
    updated () {
      this.footerHeight()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @import '~@/css/config'
  .igt_footer_nav
    >>>.site-navigation
      .navigation
        text-align center
        .navigation-item
          display: inline !important
          padding: 0 10px
  .rg-footer
    .m-b-7
      margin-bottom: 7px
  .dge
    display flex
    justify-content center
    margin 5px 0 15px 0
    @media mobile-big-and-below
      margin 10px 0 0
      img
        width 155px
  .navigationDisabledDueBetPlacement
    a
      pointer-events: none
      cursor: default
</style>



// WEBPACK FOOTER //
// src/components/layout/parts/FooterPart.vue